import classes from './SlotItem.module.sass'
import { useSlotItem } from './hooks/useSlotItem'
import { GMapForMarker } from '../../../common/components/maps/gMapForMarker/GMapForMarker'
import { format } from 'date-fns'
import { ImageGallery } from '../../../common/components/imageGallery/ImageGallery'
import { russiaCenter } from '../../../common/utils/constants'
import { StatusMenu } from '../../../common/components/statusMenu/StatusMenu'
import { StartChat } from '../../../common/components/startChat/StartChat'
import { Group, Status } from '../../../common/types/enums'
import { Helmet } from 'react-helmet-async'
import { selectCurrentUser } from '../../../store/slices/currentUserSlice'
import { useSelector } from 'react-redux'
import { ViewContact } from '../../../common/components/viewContact/ViewContact'
import { TypesSection } from '../../../common/components/typesSection/TypesSection'
import QRCode from 'react-qr-code'

export const SlotItem = () => {
  const { item, toggleSelected } = useSlotItem()
  const currentUser = useSelector(selectCurrentUser)

  if (item)
    return (
      <div className={classes.Container}>
        <Helmet>
          <title>{`logid - слот. ${item.name}${
            item.points ? `, ${item?.points[0]?.city.value}` : ''
          }`}</title>
          <meta
            name="description"
            content={`logid - слот. ${item.description} ${
              item.points ? `${item?.points[0]?.city.value}` : ''
            }`}
          />
        </Helmet>
        <div className={classes.Card}>
          <StatusMenu
            item={item}
            selectedClick={() => {
              toggleSelected(item)
            }}
            selected={Boolean(item.selected?.find((el: any) => el.user_id === currentUser?.id))}
          />
          <div className={classes.Name}>
            
            <span className={classes.Label}>Слот</span> {item && item.name}
          </div>

          <div className={classes.Description}>
            
            <span className={classes.Label}>Описание</span> {item && item.description}
          </div>

          {item.points && (
            <>
              
              <div className={classes.City}>
                
                <span className={classes.Label}>Город</span>
                {item.points[0].city.value}
              </div>
              {item.points[0].address && (
                <div className={classes.Address}>
                  
                  <span className={classes.Label}>Адрес</span>
                  {item.points[0].address.value}
                </div>
              )}
            </>
          )}

          {item.start_important && (
            <div className={classes.Time}>
              
              <span className={classes.Label}>Дата и время подачи</span>
              {format(item.startTime, 'dd.MM.yyyy HH:mm')}
            </div>
          )}

          {item.end_important && (
            <div className={classes.Time}>
              
              <span className={classes.Label}>Дата и время завершения</span>
              {format(item.endTime, 'dd.MM.yyyy HH:mm')}
            </div>
          )}

          <div className={classes.Cost}>
            
            <span className={classes.Label}>Ставка</span>
            {item.cost
              ? `${new Intl.NumberFormat('ru-RU').format(Number(item.cost))} ₽`
              : 'Не указана'}
          </div>

          {currentUser?.id !== item.userId && item.id && (
            <StartChat order={item} group={Group.SLOT} />
          )}
          {currentUser?.id === item.userId && item.status === Status.IN_WORK && item.id && (
            <StartChat order={item} group={Group.SLOT} />
          )}

          <TypesSection item={item} />

          <div className={classes.GalleryQr}>
            <ImageGallery urls={item.files} />
            <QRCode value={window.location.href} size={128} className={classes.Qr} />
          </div>

          <div className={classes.BottomSection}>
            
            <ViewContact
              visible={currentUser?.id === item.userId}
              viewData={item.views}
              contactData={item.contacts ? item.contacts : []}
              selectedData={item.selected ? item.selected : []}
            />
            {item.createdAt && item.userId === currentUser?.id && (
              <div className={classes.Id}>
                {format(new Date(item.createdAt), 'dd.MM.yyy HH:mm')}
              </div>
            )}
            <div className={classes.Id}>id: {item.id}</div>
          </div>
        </div>

        <div className={classes.MapContainer}>
          <GMapForMarker center={russiaCenter} item={item} />
        </div>
      </div>
    )
  return <></>
}
